import gql from "graphql-tag";

// Query
export const GET_TRANSACTION_HISTORY = gql`
  query transactionHistory($transaction_id: String!) {
    transactionHistory(transaction_id: $transaction_id) {
      id
      date_created
      date_updated
      model
      status
      type
      started_at
      fail_reason
      processor_response_code
      metadata {
        environment {
          response_code
          authorization_code
          authorized_amount
          captured_amount
          refunded_amount
          tid
          nsu
        }
      }
    }
  }
`;
